export default __webpack_public_path__ + "e05d2340687970a8d9cbb2beec215fd4.svg";